import PropTypes from "prop-types";
import { useState } from "react";
import { Database } from "lucide-react";

import { Button } from "@/components/ui/button";
import EventDatasetDialog from "routes/meta_datasets/swoogo_events/EventDatasetDialog";
import { UnavailableDatasetMarker } from "routes/meta_datasets/swoogo_events/EventDatasetName";
import useSwoogoEventDatasets from "routes/meta_datasets/swoogo_events/useSwoogoEventDatasets";

const EventDatasetButton = ({ eventId }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { links } = useSwoogoEventDatasets([eventId]);
  const link = links.get(eventId);

  return (
    <div className="tw:flex tw:items-center tw:gap-1.5">
      <Button variant="outline" size="sm" onClick={() => setIsDialogOpen(true)}>
        <Database data-icon="inline-start" />
        {link ? `Dataset: ${link.name}` : "Attach dataset"}
      </Button>
      {link?.unavailable && <UnavailableDatasetMarker />}
      {isDialogOpen && (
        <EventDatasetDialog
          eventIds={[eventId]}
          open
          onOpenChange={setIsDialogOpen}
        />
      )}
    </div>
  );
};

EventDatasetButton.propTypes = {
  eventId: PropTypes.number.isRequired,
};

export default EventDatasetButton;
